// Set a nivel módulo que recuerda qué turnos ya dispararon asignarPresente
// en la sesión actual. Previene que múltiples mounts del componente
// TurnoProximo (por transiciones de AnimatePresence, re-renders, etc.)
// generen llamadas duplicadas al backend.
const turnosConPresenteEnProceso = new Set();

export const marcarPresenteEnProceso = (idTurno) => {
  if (idTurno == null) return false;
  if (turnosConPresenteEnProceso.has(idTurno)) return false;
  turnosConPresenteEnProceso.add(idTurno);
  return true;
};

export const limpiarPresenteTracker = () => {
  turnosConPresenteEnProceso.clear();
};
